import OrganizationRole from '../enums/organization-roles';

interface ParentOrganization {
  id: string;
  name: string;
  parent: ParentOrganization | null;
  robotCount: number;
  role: OrganizationRole;
}

export default ParentOrganization;

export const flattenParents = (organization: ParentOrganization) => {
  const orgs: ParentOrganization[] = [];

  const flatten = (org: ParentOrganization) => {
    orgs.push({
      id: org.id,
      name: org.name,
      parent: null,
      robotCount: 0,
      role: OrganizationRole.DISTRIBUTOR,
    });
    if (org.parent != null) {
      flatten(org.parent);
    }
  };

  flatten(organization);
  return orgs;
};
